/**
 * What the security page tells search engines and link previews — ONE copy, read by today's page
 * (src/pages/Security.tsx) and its rebuild in the new design (src/design/pavilion/pages/security/), the way
 * src/config/missionSeo.ts serves both mission pages (PV5d, design record §7b).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this
 * file for "/security"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so
 * each stays one line. The description names Prest0's own audit status, which only the generated words may say
 * (scripts/check-compliance-status.mjs), so it is built from them; the index reads those words from
 * src/config/complianceStatus.generated.ts, which the same route lists.
 *
 * 2026-10-16: it said "US data residency"; Prest0 is hosted in the United States, and the model providers on the
 * Trust Center's list are not all there, so "hosted in the United States" is what is true.
 */
import { COMPLIANCE } from './complianceStatus.generated';

/** The props both security pages hand to <SeoHead>. The canonical is SeoHead's own clean address for the page. */
export const SECURITY_SEO = {
  title: 'security | prest0',
  tabTitle: 'security',
  description: `Security for law firms on Prest0: ${COMPLIANCE.soc2Type1.short}, on Google Cloud infrastructure with SOC 2 Type II and ISO 27001, hosted in the United States and encrypted in transit and at rest.`,
} as const;
